import dashboardIcon from "../../assests/sideBar/dashboard-icon.svg";
import dashboardActiveIcon from "../../assests/sideBar/dashboard-active-icon.svg";
import paymentsIcon from "../../assests/sideBar/payments-inactive.svg";
import paymentsActiveIcon from "../../assests/sideBar/payments-active-icon.svg";
import investmentsIcon from "../../assests/sideBar/investments-icon.svg";
import investmentsInactiveIcon from "../../assests/sideBar/investments-inactive-icon.svg";
import loansIcon from "../../assests/sideBar/loans-icon.svg";
import loansActiveIcon from "../../assests/sideBar/loans-active-icon.svg";
import toggleIcon from "../../assests/sideBar/toggle-icon.svg";
import toggleIcon2 from "../../assests/sideBar/toggle-icon-2.svg";
import SideBarMenu from "./menu";
import ConvertFunds from "../../components/popups/convertFunds";
import WitdrawFunds from "../../components/popups/withdrawFunds";
import SendFunds from "../../components/popups/sendFunds";
import { t } from "i18next";

const SiderBar = (props) => {
  return (
    <>
      {props.fullSidebar && (
        <aside
          style={props.expandedView ? { zIndex: "4" } : {}}
          id="side-bar-id"
          className="side-bar"
        >
          <SideBarMenu
            name={t("footer.dashboard")}
            iconInActive={dashboardIcon}
            iconActive={dashboardActiveIcon}
            dropdowns={[]}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />
          <SideBarMenu
            name={t("footer.payments")}
            iconInActive={paymentsIcon}
            iconActive={paymentsActiveIcon}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            dropdowns={[
              // {
              //   name: "Add Funds",
              //   onClickPopup: (
              //     <AddFunds
              //       setPopupContent={props.setPopupContent}
              //       setShowPopup={props.setShowPopup}
              //       setPopupContentPosition={props.setPopupContentPosition}
              //       setFavouriteClicked={props.setFavouriteClicked}
              //       customLoading={props.customLoading}
              //       setCustomLoading={props.setCustomLoading}
              //       generalDataProps={props.generalDataProps}
              //       addFundsAction="add-funds"
              //     />
              //   ),
              // },
              {
                name: "Send Funds",
                onClickPopup: (
                  <SendFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
              {
                name: "Convert Funds",
                onClickPopup: (
                  <ConvertFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
              {
                name: "Withdraw Funds",
                onClickPopup: (
                  <WitdrawFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
            ]}
            generalShowFullSideBar={true}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />
          <SideBarMenu
            name={t("footer.investments")}
            iconInActive={investmentsInactiveIcon}
            iconActive={investmentsIcon}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            dropdowns={[
              { name: `${t("investments.assets")}` },
              { name: `${t("investments.portfolio")}` },
              { name: `${t("investments.orders")}` },
              // { name: "Watchlists" },
            ]}
            generalShowFullSideBar={true}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />
          {process.env.REACT_APP_NODE_ENV !== "production" && (
            <SideBarMenu
              name={t("footer.loans")}
              iconInActive={loansIcon}
              iconActive={loansActiveIcon}
              dropdowns={[{ name: `${t("borrow.borrow")}` }, { name: "Lend" }]}
              fullSidebar={props.fullSidebar}
              setFullSidebar={props.setFullSidebar}
              generalShowFullSideBar={true}
              setPopupContent={props.setPopupContent}
              setShowPopup={props.setShowPopup}
              setPopupContentPosition={props.setPopupContentPosition}
              setFavouriteClicked={props.setFavouriteClicked}
            />
          )}
          <div
            onClick={() => {
              props.setFullSidebar(false);
            }}
            className="menu-toggle"
          >
            <img
              alt="Menu Toggle Icon"
              src={toggleIcon}
              className="menu-toggle-icon"
            />
          </div>
        </aside>
      )}
      {!props.fullSidebar && (
        <aside
          style={props.expandedView ? { zIndex: "4" } : {}}
          id="side-bar-id"
          className="side-bar"
        >
          <SideBarMenu
            name={t("footer.dashboard")}
            iconInActive={dashboardIcon}
            iconActive={dashboardActiveIcon}
            dropdowns={[]}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />
          <SideBarMenu
            name={t("footer.payments")}
            iconInActive={paymentsIcon}
            iconActive={paymentsActiveIcon}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            dropdowns={[
              // {
              //   name: "Add Funds",
              //   onClickPopup: (
              //     <AddFunds
              //       setPopupContent={props.setPopupContent}
              //       setShowPopup={props.setShowPopup}
              //       setPopupContentPosition={props.setPopupContentPosition}
              //       setFavouriteClicked={props.setFavouriteClicked}
              //       customLoading={props.customLoading}
              //       setCustomLoading={props.setCustomLoading}
              //       generalDataProps={props.generalDataProps}
              //       addFundsAction="add-funds"
              //     />
              //   ),
              // },
              {
                name: "Send Funds",
                onClickPopup: (
                  <SendFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
              {
                name: "Convert Funds",
                onClickPopup: (
                  <ConvertFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
              {
                name: "Withdraw Funds",
                onClickPopup: (
                  <WitdrawFunds
                    setPopupContent={props.setPopupContent}
                    setShowPopup={props.setShowPopup}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    customLoading={props.customLoading}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                  />
                ),
              },
            ]}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />
          <SideBarMenu
            name={t("footer.investments")}
            iconInActive={investmentsInactiveIcon}
            iconActive={investmentsIcon}
            fullSidebar={props.fullSidebar}
            setFullSidebar={props.setFullSidebar}
            dropdowns={[
              { name: `${t("investments.assets")}` },
              { name: `${t("investments.portfolio")}` },
              { name: `${t("investments.orders")}` },

              // { name: "Watchlists" },
            ]}
            setPopupContent={props.setPopupContent}
            setShowPopup={props.setShowPopup}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
          />

          {process.env.REACT_APP_NODE_ENV !== "production" && (
            <SideBarMenu
              name={t("footer.loans")}
              iconInActive={loansIcon}
              iconActive={loansActiveIcon}
              fullSidebar={props.fullSidebar}
              setFullSidebar={props.setFullSidebar}
              dropdowns={[{ name: `${t("borrow.borrow")}` }, { name: "Lend" }]}
              setPopupContent={props.setPopupContent}
              setShowPopup={props.setShowPopup}
              setPopupContentPosition={props.setPopupContentPosition}
              setFavouriteClicked={props.setFavouriteClicked}
            />
          )}

          <div
            onClick={() => {
              props.setFullSidebar(true);
            }}
            className="menu-toggle"
          >
            <img
              alt="Menu Toggle Icon"
              src={toggleIcon2}
              className="menu-toggle-icon"
            />
          </div>
        </aside>
      )}
    </>
  );
};

export default SiderBar;
